var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquares4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0H6.5C6.3625 0 6.25 0.1125 6.25 0.25V5C6.25 5.1375 6.3625 5.25 6.5 5.25H11.25C11.3875 5.25 11.5 5.1375 11.5 5V0.25C11.5 0.1125 11.3875 0 11.25 0ZM11.25 6.25H6.5C6.3625 6.25 6.25 6.3625 6.25 6.5V11.25C6.25 11.3875 6.3625 11.5 6.5 11.5H11.25C11.3875 11.5 11.5 11.3875 11.5 11.25V6.5C11.5 6.3625 11.3875 6.25 11.25 6.25ZM5 0H0.25C0.1125 0 0 0.1125 0 0.25V5C0 5.1375 0.1125 5.25 0.25 5.25H5C5.1375 5.25 5.25 5.1375 5.25 5V0.25C5.25 0.1125 5.1375 0 5 0ZM5 6.25H0.25C0.1125 6.25 0 6.3625 0 6.5V11.25C0 11.3875 0.1125 11.5 0.25 11.5H5C5.1375 11.5 5.25 11.3875 5.25 11.25V6.5C5.25 6.3625 5.1375 6.25 5 6.25Z",
    fill: "inherit",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquares4);
export default __webpack_public_path__ + "static/media/squares-4.a2e62ee943a6d1aa9b767214d6c69fa5.svg";
export { ForwardRef as ReactComponent };